const asText = (value) => value?.toString?.().trim?.() ?? "";

export const getInitialFinalReviewActionComments = ({
  action,
  commentsOn,
  generalReviewComments,
  rowReviewComments,
}) => {
  if (!commentsOn) return "";

  if (action === "return" || action === "reject") {
    return asText(generalReviewComments);
  }

  return asText(rowReviewComments);
};
